// extracted by mini-css-extract-plugin
export default {"badgeLabel":"GemDropdown_badgeLabel__JbPlP"};